export default "__VITE_ASSET__aASvmZ3j__"